import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.scss';

const Double = props => {
  const { item } = props;
  return (
    <div className={styles.value}>
      {item.prevValue && item.newValue && item.prevCode && item.newCode ? (
        <React.Fragment>
          {item.prevValue && <span className={styles.prev}>{item.prevValue}</span>}
          {item.prevCode && <span className={styles.prev}>{item.prevCode}</span>}
          {item.newValue && <span className={styles.new}>{item.newValue}</span>}
          {item.newCode && <span className={styles.new}>{item.newCode}</span>}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <span className={styles.first}>
            {!item.prevValue && !item.newValue ? (
              <span>{item.value}</span>
            ) : (
              <React.Fragment>
                {item.prevValue && <span className={styles.prev}>{item.prevValue}</span>}
                {item.newValue && <span className={styles.new}>{item.newValue}</span>}
              </React.Fragment>
            )}
          </span>
          <span className={styles.second}>
            {!item.prevCode && !item.newCode ? (
              <span>{item.code}</span>
            ) : (
              <React.Fragment>
                {item.prevCode && <span className={styles.prev}>{item.prevCode}</span>}
                {item.newCode && <span className={styles.new}>{item.newCode}</span>}
              </React.Fragment>
            )}
          </span>
        </React.Fragment>
      )}
    </div>
  );
};

Double.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Double;
